import React from 'react';

import { styled } from '../theme';
import ScrollArea from './ScrollArea';

type Props = {
    stripes?: boolean;
    persistentScrollbar?: boolean;
};

const TableContainer = styled('div')({
    width: '100%',
    maxWidth: '100%',
    overflowX: 'auto',
});

const StyledTable = styled('table')<Props>(({ theme, stripes }) => ({
    width: '100%',
    tableLayout: 'auto',
    fontFamily: theme.typography.fontFamily,
    color: theme.color.jetBlack,
    ...(stripes && {
        'tbody tr:nth-of-type(odd)': {
            background: theme.color.tableZebraStripeGray,
        },
    }),
}));

const Table = ({
    persistentScrollbar,
    ...props
}: Props & React.TableHTMLAttributes<HTMLTableElement>) => {
    const table = <StyledTable {...props} />;

    return persistentScrollbar ? (
        <ScrollArea>{table}</ScrollArea>
    ) : (
        <TableContainer>{table}</TableContainer>
    );
};

export default Table;
